import {
  atan2,
  chain,
  derivative,
  e,
  evaluate,
  log,
  pi,
  pow,
  round,
  sqrt,
} from "mathjs";

import { getAgeFromDate, decimalNumberFormatter } from "./OtherFunctions";

export const onMultiSelectCheckBoxClick = (
  selectedValues,
  type,
  maxSelect,
  minSelect
) => {
  console.log("onMultiSelectCheckBoxClick_tempValue", selectedValues);
  console.log("onMultiSelectCheckBoxClick_tempValue_type", type);
  var array2Index = "";
  selectedValues = selectedValues.split(",");
  if (selectedValues.length > maxSelect) {
    //console.log("CustomMultiCheckBox_max","Max Select Exuasted");
    // selectedValues.pop();
    alert("Can't Select more than " + maxSelect);
  } else if (selectedValues.length < minSelect) {
    //console.log("CustomMultiCheckBox_min","Min Select Exuasted");
    alert("Select at least " + minSelect);
  } else {
    for (var i = 0; i < selectedValues.length; i++) {
      if (type == "multiselectt1") {
        array2Index += i + 1 + ". " + selectedValues[i] + "<br>";
      } else if (type == "multiselectt2") {
        array2Index += selectedValues[i] + ", ";
      } else if (type == "multiselectt3") {
        array2Index += selectedValues[i] + "<br>";
      } else if (type == "multiselectt4") {
        //Ordered
        array2Index += "<li>" + selectedValues[i] + "</li>";
      } else if (type == "multiselectt5") {
        //UnOrdered
        array2Index += "<li>" + selectedValues[i] + "</li>";
      }
    }
    //DevNote[27-03-2023]: CodeToHandle OL or UL
    if (type == "multiselectt4") {
      //Ordered
      array2Index = "<ol>" + array2Index + "</ol>";
    }
    if (type == "multiselectt5") {
      //UnOrdered
      array2Index = "<ul>" + array2Index + "</ul>";
    }
  }
  console.log("onMultiSelectCheckBoxClick_tempValue_array2Index", array2Index);
  return array2Index;
};

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function rendringInputValueStyle(styles, value, maxLength) {
  if (styles.length > 0) {
    if (styles.some((item) => item === "commasepnum1")) {
      value = numberWithCommas(value);
    }

    if (styles.some((item) => item === "allcaps")) {
      value = value.toUpperCase(); // Returns "HELLO WORLD!"
    }

    if (styles.some((item) => item === "boxed")) {
      value = boxedChars(value, maxLength);
    }
  }
  return value;
}

function boxedChars(value, maxLength) {
  var sp = "";
  for (var i = 0; i < maxLength; i++) {
    var html = value.substr(i, 1);
    //display: inline;
    if (html == "" || html == " ") {
      html = "&nbsp; &nbsp; ";
    } else {
      html = "&nbsp;" + html + "&nbsp;";
    }
    sp +=
      "<span style='display:inline-block; text-align:center; border: 1px solid rgba(0,0,0,0.3); min-width:25px '>" +
      html +
      "</span>&nbsp;";
  }
  return sp;
}

function getKeysFromTemplateString(templateString) {
  var keysFound = [], // an array to collect the strings that are found
    rxp = /{([^}]+)}/g,
    // str = "a {string} with {curly} braces",
    curMatch;
  while ((curMatch = rxp.exec(templateString))) {
    keysFound.push(curMatch[1]);
  }
  // console.log( keysFound );    // ["string", "curly"]
  return keysFound;
}

//TemplateRenderingFunctions.js
export function addAddtionalKeyToSubTemplate(
  formFieldInput,
  inputfields,
  subFormTemplate,
  keyAddOn,
  loopCount
) {
  // console.log(
  //   "addAddtionalKeyToSubTemplate_inputfields",
  //   "---------------------------"
  // );
  // console.log("addAddtionalKeyToSubTemplate_formFieldInput.elementUId");
  // console.log("addAddtionalKeyToSubTemplate_inputfields", inputfields);
  // console.log("addAddtionalKeyToSubTemplate_subFormTemplate", subFormTemplate);
  // console.log("addAddtionalKeyToSubTemplate_keyAddOn", keyAddOn);
  // console.log("addAddtionalKeyToSubTemplate_loopCount", loopCount);

  // console.log(
  //   "addAddtionalKeyToSubTemplate_subParentKey",
  //   keyAddOn.replace(formFieldInput.elementUId, "")
  // );

  // console.log("addAddtionalKeyToSubTemplate_otherFieldsTemplateInKeys_getKeysFromTemplateString",getKeysFromTemplateString(subFormTemplate))
  let otherFieldsTemplateInKeys = getKeysFromTemplateString(subFormTemplate); //subFormTemplate.split(/{([^}]*)}/);
  // console.log(
  //   "addAddtionalKeyToSubTemplate_otherFieldsTemplateInKeys",
  //   otherFieldsTemplateInKeys
  // );

  // var mySubString = subFormTemplate.match(new RegExp(/{([^}]*)}/));
  // console.log("addAddtionalKeyToSubTemplate_otherFieldsTemplateInKeys_mySubString",mySubString)

  if (otherFieldsTemplateInKeys.length > 0) {
    // console.log(
    //   "addAddtionalKeyToSubTemplate_otherFieldsTemplateInKeys.length",
    //   otherFieldsTemplateInKeys.length
    // );

    otherFieldsTemplateInKeys.forEach((otherFieldsTemplateInKey) => {
      // console.log(
      //   "addAddtionalKeyToSubTemplate_otherFieldsTemplateInKey",
      //   otherFieldsTemplateInKey
      // );
      if (otherFieldsTemplateInKey.replace(/\s/g, "").length > 0) {
        // console.log(
        //   "addAddtionalKeyToSubTemplate_otherFieldsTemplateInKey",
        //   otherFieldsTemplateInKey
        // );

        let templateKeyCombination = otherFieldsTemplateInKey.split(".");

        if (templateKeyCombination.length > 1) {
          let templateKeyCombinationString = "";

          // templateKeyCombinationString=templateKeyCombination[1] + templateKeyCombination[0]//DevNote[AddedOn]:old flow
          // console.log("templateKeyCombinationString_pre",templateKeyCombination[1] + templateKeyCombination[0]);

          for (let i = templateKeyCombination.length - 1; i >= 0; i--) {
            // console.log("templateKeyCombinationString_i",i);
            templateKeyCombinationString =
              templateKeyCombinationString + templateKeyCombination[i];
            // console.log("templateKeyCombinationString_templateKeyCombination",templateKeyCombination);
            // console.log("templateKeyCombinationString_templateKeyCombination_add_on",keyAddOn.replace(formFieldInput.elementUId, ""));
            // console.log("templateKeyCombinationString_templateKeyCombination_formFieldInput",formFieldInput);
          }

          //DevNote[AddedOn]:16-03-2022: temperary Solution
          if (templateKeyCombination.length > 3) {
            //DevNote[AddedOn]:22-03-2022, To Be working with Global
            // console.log("templateKeyCombinationString_zero_>3","Start");
            templateKeyCombinationString =
              templateKeyCombinationString +
              "0" +
              keyAddOn.replace(formFieldInput.elementUId, "") +
              "0"; //Old
            // console.log("templateKeyCombinationString_zero_>3","end");
          } else if (templateKeyCombination.length > 2) {
            //DevNote[Flow]:will work with fields at same level
            templateKeyCombinationString =
              templateKeyCombinationString +
              keyAddOn.replace(formFieldInput.elementUId, "") +
              "0"; //Old
            /*NotWorking
            let zeroExtention="";
            for (let j = templateKeyCombination.length-3; j >= 0; j--) {
              zeroExtention=zeroExtention+"0";
            }
            console.log("templateKeyCombinationString_zero","Start");
            console.log("templateKeyCombinationString_zero_keyAddOn",keyAddOn);
            console.log("templateKeyCombinationString_zero_formFieldInput.elementUId",formFieldInput.elementUId);
            console.log("templateKeyCombinationString_zero_templateKeyCombinationString",templateKeyCombinationString);
            console.log("templateKeyCombinationString_zero_keyAddOn.replace",keyAddOn.replace(formFieldInput.elementUId, ""));
            console.log("templateKeyCombinationString_zero_templateKeyCombination",templateKeyCombination);
            console.log("templateKeyCombinationString_zero_zeroExtention",zeroExtention);
            console.log("templateKeyCombinationString_zero_keyAddOn","End");
            // templateKeyCombinationString=templateKeyCombinationString+keyAddOn.replace(formFieldInput.elementUId, "")+zeroExtention;
            console.log("templateKeyCombinationString_zero_templateKeyCombinationString2Return",templateKeyCombinationString);
            console.log("templateKeyCombinationString_zero","End");
            */
          } else {
            //DevNote[Flow]:Below is Original
            templateKeyCombinationString =
              templateKeyCombinationString +
              keyAddOn.replace(formFieldInput.elementUId, "");
          }

          // console.log("templateKeyCombinationString_post",templateKeyCombinationString);
          // console.log(
          //   "addAddtionalKeyToSubTemplate_templateKeyCombination",
          //   templateKeyCombination
          // );
          //DevNotes[ModifyOn]: 16-03-2022
          subFormTemplate = subFormTemplate.replace(
            new RegExp("{" + otherFieldsTemplateInKey + "}", "gi"),
            "{" + templateKeyCombinationString + "}"
          );
          //Old
          // subFormTemplate = subFormTemplate.replace(
          //   new RegExp("{" + otherFieldsTemplateInKey + "}", "gi"),
          //   "{" +
          //     templateKeyCombination[1] +
          //     templateKeyCombination[0] +
          //     keyAddOn.replace(formFieldInput.elementUId, "") +
          //     "}"
          // );
        }
      }
    });
  }

  if (inputfields != null && inputfields != undefined) {
    // console.log("-addAddtionalKeyToSubTemplate-");
    // console.log("inputfields", inputfields);
    // console.log("subFormTemplate", subFormTemplate);
    // console.log("keyAddOn", keyAddOn);
    /*
    Object.keys(inputfields).map(
      (key,val) =>
        (
          subFormTemplate = subFormTemplate.replace(
          new RegExp("{" + key + "}", "gi"),
          "{" + key + keyAddOn + "}"
        )          
        )
        //console.log("ssads")
    );
    */
    Object.keys(inputfields).forEach(function (key) {
      //console.log("-key-", key);
      //console.log("testFields_key", formFields[key]);
      //formsFieldsDataSortedTemp.push(formFields[key]);
      let inputfield = inputfields[key];
      //console.log("inputfield", inputfield);
      if (inputfield.isGlobal == true) {
        subFormTemplate = subFormTemplate.replace(
          new RegExp("{" + key + "}", "gi"),
          "{" + key + "}"
        );
      } else {
        subFormTemplate = subFormTemplate.replace(
          new RegExp("{" + key + "}", "gi"),
          "{" + key + keyAddOn + "}"
        );
      }
      //console.log("subFormTemplate", subFormTemplate);
    });
  }

  console.log(
    "addAddtionalKeyToSubTemplate_subFormTemplate_toreturn",
    subFormTemplate
  );

  //[SHW_CNT]//To Add/Show Count, s.no. like 1,2,3,4,5,6
  //[SHW_CNT_ALP]//To Add/Show Count, s.no. like A,B,C,D,E,F
  //[SHW_CNT_ALP_L]//To Add/Show Count, s.no. like a,b,c,d
  //[SHW_HYN]//To Add/Show HYPHEN(-) i.e. &#8209;
  //[SHW_BLT]//To Add/Show Bullets i.e. &#8226;
  //[SHW_TBLT]//To Add/Show TRIANGULAR BULLET i.e. &#8227;
  //[SHW_SLPA]//To Add/SINGLE LEFT-POINTING ANGLE QUOTATION MARK(<) i.e. &#8249;
  //[SHW_SRPA]//To Add/SINGLE Right-POINTING ANGLE QUOTATION MARK(>) i.e. &#8250;
  //[SHW_DLPA]//To Add/DOUBLE LEFT-POINTING ANGLE QUOTATION MARK(<<) i.e. &#171;
  //[SHW_DRPA]//To Add/DOUBLE Right-POINTING ANGLE QUOTATION MARK(<>) i.e. &#187;
  //[SHW_CNT_RMN]//To Add/Show Roman Counting
  //[SHW_CNT_ORD_SUP]
  if (subFormTemplate.indexOf("[SHW_CNT]") > 0) {
    return subFormTemplate.replace("[SHW_CNT]", loopCount + 1);
  } else if (subFormTemplate.indexOf("[SHW_CNT_ALP]") > 0) {
    return subFormTemplate.replace(
      "[SHW_CNT_ALP]",
      (loopCount + 1 + 9).toString(36).toUpperCase()
    );
  } else if (subFormTemplate.indexOf("[SHW_CNT_ALP_L]") > 0) {
    return subFormTemplate.replace(
      "[SHW_CNT_ALP_L]",
      (loopCount + 1 + 9).toString(36).toLowerCase()
    );
  } else if (subFormTemplate.indexOf("[SHW_CNT_ORD_SUP]") > 0) {
    return subFormTemplate.replace(
      "[SHW_CNT_ORD_SUP]",
      ordinal_suffix_sup_of(loopCount + 1)
    );
  } else if (subFormTemplate.indexOf("[SHW_CNT_RMN]") > 0) {
    // console.log("custom_chw_cnt","[SHW_CNT_RMN]")
    return subFormTemplate.replace(
      "[SHW_CNT_RMN]",
      intToRoman(loopCount + 1)
    );
  } else {
    return subFormTemplate;
  }
}

function intToRoman(num) {
  // console.log("custom_chw_cnt_intToRoman",num)
  if (typeof num !== "number" || num <= 0 || num > 3999) {
    return "Invalid number. Please enter a positive integer between 1 and 3999.";
  }
  let roman = "";

  roman += "M".repeat(num / 1000);
  num %= 1000;
  roman += "CM".repeat(num / 900);
  num %= 900;
  roman += "D".repeat(num / 500);
  num %= 500;
  roman += "CD".repeat(num / 400);
  num %= 400;
  roman += "C".repeat(num / 100);
  num %= 100;
  roman += "XC".repeat(num / 90);
  num %= 90;
  roman += "L".repeat(num / 50);
  num %= 50;
  roman += "XL".repeat(num / 40);
  num %= 40;
  roman += "X".repeat(num / 10);
  num %= 10;
  roman += "IX".repeat(num / 9);
  num %= 9;
  roman += "V".repeat(num / 5);
  num %= 5;
  roman += "IV".repeat(num / 4);
  num %= 4;
  roman += "I".repeat(num);

  return roman;
}

function ordinal_suffix_of(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

function ordinal_suffix_sup_of(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "<sup>st</sup>";
  }
  if (j == 2 && k != 12) {
    return i + "<sup>nd</sup>";
  }
  if (j == 3 && k != 13) {
    return i + "<sup>rd</sup>";
  }
  return i + "<sup>th</sup>";
}

String.prototype.replaceAt = function (index, replacement) {
  return (
    this.substr(0, index) +
    replacement +
    this.substr(index + replacement.length)
  );
};

export function populateSubConditonalForm(
  formFieldInput,
  populateCount,
  conditionalFormFieldValue,
  templateKey,
  multiSelectedValues
) {
  console.log(
    "----------------------------populateSubConditonalForm--------------------------"
  );
  console.log("populateSubConditonalForm_templateKey", templateKey);

  console.log(
    "populateSubConditonalForm_formFieldInput.elementUId--",
    formFieldInput.elementUId
  );
  //let templateElementIdKey=formFieldInput.elementUId;
  console.log("populateSubConditonalForm_formFieldInput", formFieldInput);

  console.log("populateSubConditonalForm_populateCount", populateCount);
  console.log(
    "populateSubConditonalForm_conditionalFormFieldValue",
    conditionalFormFieldValue
  );
  console.log(
    "populateSubConditonalForm_multiSelectedValues",
    multiSelectedValues
  );

  let templateElementIdKey = templateKey;
  console.log(
    "populateSubConditonalForm_templateElementIdKey-",
    templateElementIdKey
  );
  var rows = "<p></p>";

  //ToProcess copyOfInput Conditional Template
  /*
  if (formFieldInput.elementType == "copyOfInput"){
    
    console.log("copyOfInput_inpopcondi_formFieldInput",formFieldInput);

    console.log("copyOfInput_inpopcondi_formFieldInput.condition.conditionType",formFieldInput.condition.conditionType)

    if(formFieldInput.condition.conditionType=="ValueBased"){
      if (
        formFieldInput.condition.conditionStatements[conditionalFormFieldValue] !=
        undefined
      ) {
        rows = addAddtionalKeyToSubTemplate(
          formFieldInput,
          formFieldInput.condition.conditionStatements[conditionalFormFieldValue]
            .subFormFields.formFields,
          formFieldInput.condition.conditionStatements[conditionalFormFieldValue]
            .subFormTemplate,
          "" + templateElementIdKey + 0,
          0
        );
      } else {
        rows = addAddtionalKeyToSubTemplate(
          formFieldInput,
          {},
          "",
          "" + templateElementIdKey + 0,
          0
        );
      }
    }else{
      rows = addAddtionalKeyToSubTemplate(
        formFieldInput,
        formFieldInput.condition.subFormFields.formFields,
        formFieldInput.condition.subFormTemplate,
        "" + templateElementIdKey + 0,
        0
      );
      for (var i = 1; i < populateCount; i++) {
        rows += addAddtionalKeyToSubTemplate(
          formFieldInput,
          formFieldInput.condition.subFormFields.formFields,
          formFieldInput.condition.subFormTemplate,
          "" + templateElementIdKey + i,
          i
        );
      }
    }
  }else 
  */
  if (
    formFieldInput.elementType.toLowerCase() == "select" ||
    formFieldInput.elementType.toLowerCase() == "radio" ||
    formFieldInput.elementType.toLowerCase() == "datalist" ||
    (formFieldInput.elementType == "copyOfInput" &&
      formFieldInput.condition.conditionType == "ValueBased")
  ) {
    /*formId = props.mainDocumentFormField.condition.conditionStatements[props.formFieldValue].subFormId;
        formsFieldsDataDefault = formFieldInput.condition.conditionStatements[conditionalFormFieldValue].subFormFields; //setFormsFieldsData()
        sampleFormDataForEditor = formFieldInput.condition.conditionStatements[conditionalFormFieldValue].subFormTemplate;
    */
    if (
      formFieldInput.condition.conditionStatements[conditionalFormFieldValue] !=
      undefined
    ) {
      rows = addAddtionalKeyToSubTemplate(
        formFieldInput,
        formFieldInput.condition.conditionStatements[conditionalFormFieldValue]
          .subFormFields.formFields,
        formFieldInput.condition.conditionStatements[conditionalFormFieldValue]
          .subFormTemplate,
        "" + templateElementIdKey + 0,
        0
      );
    } else {
      rows = addAddtionalKeyToSubTemplate(
        formFieldInput,
        {},
        "",
        "" + templateElementIdKey + 0,
        0
      );
    }
  } else if (
    formFieldInput.elementType.toLowerCase() == "checkbox" &&
    (formFieldInput.elementConfig.type.toLowerCase() == "multiselectt1" ||
      formFieldInput.elementConfig.type.toLowerCase() == "multiselectt2" ||
      formFieldInput.elementConfig.type.toLowerCase() == "multiselectt3" ||
      formFieldInput.elementConfig.type.toLowerCase() == "multiselectt4" ||
      formFieldInput.elementConfig.type.toLowerCase() == "multiselectt5")
  ) {
    //AddedOn 13-12-2021
    console.log(
      "populateSubConditonalForm_multicheckbox_formFieldInput",
      formFieldInput
    );
    console.log(
      "populateSubConditonalForm_multicheckbox_conditionalFormFieldValue",
      conditionalFormFieldValue
    );

    //rows="<p>MultiChoiceCheckBox multiSelectedValue</p>";
    let selectedValueRow = "";
    let selectedValueRowJson = {};
    multiSelectedValues.forEach((selectedValue) => {
      console.log(
        "populateSubConditonalForm_multicheckbox_selectedValue",
        selectedValue
      );
      let selectedValueRowTemp = "";
      if (
        formFieldInput.condition.conditionStatements[selectedValue] != undefined
      ) {
        selectedValueRowTemp = addAddtionalKeyToSubTemplate(
          formFieldInput,
          formFieldInput.condition.conditionStatements[selectedValue]
            .subFormFields.formFields,
          formFieldInput.condition.conditionStatements[selectedValue]
            .subFormTemplate,
          "" + templateElementIdKey + 0,
          0
        );
      } else {
        selectedValueRowTemp = addAddtionalKeyToSubTemplate(
          formFieldInput,
          {},
          "",
          "" + templateElementIdKey + 0,
          0
        );
      }
      selectedValueRowJson[selectedValue] = selectedValueRowTemp;
      // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowTemp", selectedValueRowTemp);
      // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowTempV2", conditionalFormFieldValue+selectedValueRowTemp);
      // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowTempV3", conditionalFormFieldValue.replace(selectedValue,selectedValueRowTemp));
      selectedValueRow = selectedValueRow + selectedValueRowTemp;
      //selectedValueRow=selectedValueRow+conditionalFormFieldValue+selectedValueRowTemp;//Concating Value with SubTemplate //Will Not Show Value in main render
      // selectedValueRow=selectedValueRow+conditionalFormFieldValue.replace(selectedValue,selectedValueRowTemp);
    });

    // rows=selectedValueRow;
    // console.log("populateSubConditonalForm_multicheckbox_rows", rows);
    // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowJson", selectedValueRowJson);

    Object.entries(selectedValueRowJson).map(([key, val]) => {
      // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowJson_key", key);
      // console.log("populateSubConditonalForm_multicheckbox_selectedValueRowJson_val", val);
      // if(val.length>0){//No Need Of This Now
      //16-12-2010 To Process: MultiSelectedCheckBox
      let tempVal = "";
      if (val != undefined && val != null && val.length > 0) {
        tempVal = val;
      }
      if (formFieldInput.isHidden == true) {
        // console.log(
        //   "populateSubConditonalForm_multicheckbox_formFieldInput.isHidden",
        //   "formFieldInput.isHidden"
        // );
        //Appending MultiSelcted Option
        // conditionalFormFieldValue = conditionalFormFieldValue.replace(
        //   new RegExp(key, "gi"),
        //   key+" "+val
        // );
        conditionalFormFieldValue = conditionalFormFieldValue.replace(
          new RegExp(key, "gi"),
          tempVal
        );
      } else {
        console.log(
          "populateSubConditonalForm_multicheckbox_formFieldInput.isHidden",
          "formFieldInput.is not Hidden"
        );
        //Appending MultiSelcted Option
        conditionalFormFieldValue = conditionalFormFieldValue.replace(
          new RegExp(key, "gi"),
          key + " " + tempVal
        );
      }
      // }
    });

    console.log(
      "populateSubConditonalForm_multicheckbox_selectedValueRowJson_conditionalFormFieldValue",
      conditionalFormFieldValue
    );
    rows = conditionalFormFieldValue;
  } else {
    // console.log(
    //   "formFieldInput.condition.subFormTemplate",
    //   formFieldInput.condition.subFormTemplate
    // );
    // console.log(
    //   "formFieldInput.condition.subFormFields.formFields",
    //   formFieldInput.condition.subFormFields.formFields
    // );
    rows = addAddtionalKeyToSubTemplate(
      formFieldInput,
      formFieldInput.condition.subFormFields.formFields,
      formFieldInput.condition.subFormTemplate,
      "" + templateElementIdKey + 0,
      0
    );
    for (var i = 1; i < populateCount; i++) {
      rows += addAddtionalKeyToSubTemplate(
        formFieldInput,
        formFieldInput.condition.subFormFields.formFields,
        formFieldInput.condition.subFormTemplate,
        "" + templateElementIdKey + i,
        i
      );
    }
  }
  //console.log("--------rows----------",rows.replace("<p>", "<p class='inlineSubField'>"))
  return rows.replace("<p>", "<p class='inlineSubField'>");
}

export function replaceTemplateKeyWithFormDataViewTT(
  mainTemplate,
  formFieldKey,
  conditionalTemplate
) {
  mainTemplate = mainTemplate.replace(
    new RegExp("{" + formFieldKey + "}", "gi"),
    "{" + formFieldKey + "}" + conditionalTemplate
  );
  return mainTemplate;
}

export function replaceTemplateKeyWithFormDataViewTTV2(
  mainTemplate,
  keyValueTemplates
) {
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_keyValueTemplates",
    keyValueTemplates
  );

  //ToProcess Golbal InoutTemplae field for template that is render after selecting main i.e. sub condition is below main
  //use above for that Object.keys(keyValueTemplates).slice().reverse().forEach((key) => {
  //Above 2 Lines added on 31-01-2022

  Object.keys(keyValueTemplates).forEach((key) => {
    console.log("replaceTemplateKeyWithFormDataViewTTV2_key", key);
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_keyValueTemplates[key]",
      keyValueTemplates[key]
    );
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_pre_" + key + "_mainTemplate",
      mainTemplate
    );
    mainTemplate = mainTemplate.replace(
      new RegExp("{" + key + "}", "gi"),
      "{" + key + "}" + keyValueTemplates[key]
    );
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_post_" + key + "_mainTemplate",
      mainTemplate
    );
  });
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );

  let mainTemplate2 = mainTemplate.replace(
    new RegExp("</p><p class='inlineSubField'>", "gi"),
    ""
  );
  //console.log("*****************--mainTemplate2---",mainTemplate2)

  mainTemplate = mainTemplate2;
  let mainTemplate3 = mainTemplate.replace(
    new RegExp("<p class='inlineSubField'>", "gi"),
    ""
  );
  //console.log("*****************--mainTemplate3---",mainTemplate3)
  mainTemplate = mainTemplate3;
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );
  return mainTemplate;
}

export function replaceTemplateKeyWithFormDataViewNew(
  mainTemplate,
  keyValueTemplates,
  keyValueTemplatesTemp
) {
  console.log(
    "*---------------replaceTemplateKeyWithFormDataViewNew---------------*"
  );
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_keyValueTemplates",
    keyValueTemplates
  );
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_keyValueTemplatesTemp",
    keyValueTemplatesTemp
  );
  Object.keys(keyValueTemplates).forEach((key) => {
    console.log("replaceTemplateKeyWithFormDataViewTTV2_key", key);
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_keyValueTemplates[key]",
      keyValueTemplates[key]
    );
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_pre_" + key + "_mainTemplate",
      mainTemplate
    );
    mainTemplate = mainTemplate.replace(
      new RegExp("{" + key + "}", "gi"),
      "{" + key + "}" + keyValueTemplates[key]
    );
    console.log(
      "replaceTemplateKeyWithFormDataViewTTV2_post_" + key + "_mainTemplate",
      mainTemplate
    );
  });
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );

  let mainTemplate2 = mainTemplate.replace(
    new RegExp("</p><p class='inlineSubField'>", "gi"),
    ""
  );
  //console.log("*****************--mainTemplate2---",mainTemplate2)

  mainTemplate = mainTemplate2;
  let mainTemplate3 = mainTemplate.replace(
    new RegExp("<p class='inlineSubField'>", "gi"),
    ""
  );
  //console.log("*****************--mainTemplate3---",mainTemplate3)
  mainTemplate = mainTemplate3;
  console.log(
    "replaceTemplateKeyWithFormDataViewTTV2_mainTemplate",
    mainTemplate
  );
  return mainTemplate;
}

export function fetchFormulaObjectV2(formulaValue) {
  var formulaObject = {};
  console.log("mainFormFields_fetchFormulaObject:Start---");
  console.log("mainFormFields_fetchFormulaObject_formulaValue", formulaValue);

  formulaObject["action"] = formulaValue.split("(")[0];

  console.log(
    "mainFormFields_fetchFormulaObject_formulaObject[action]",
    formulaObject["action"]
  );

  var noOfFieldsKeys = [];
  var formulaObjectVars = formulaValue.substring(
    formulaValue.indexOf("(") + 1,
    formulaValue.lastIndexOf(")")
  );
  console.log(
    "mainFormFields_fetchFormulaObject_formulaObjectVars",
    formulaObjectVars
  );
  formulaObject["actionString"] = formulaObjectVars;

  if (formulaObject["action"] == "eval") {
    //var formulaObjectVarsTest=formulaObjectVars.replace("(","");
    //formulaObjectVarsTest=formulaObjectVarsTest.replace(")","");
    var formulaObjectVarsClean = formulaObjectVars.replace(/[()]/g, "");
    noOfFieldsKeys = formulaObjectVarsClean
      .split(/[+-/%*]+/)
      .map((item) => item.trim());
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
  } else if (
    formulaObject["action"] == "sum" ||
    formulaObject["action"] == "diff" ||
    formulaObject["action"] == "average" ||
    formulaObject["action"] == "multiple"
  ) {
    noOfFieldsKeys[0] = formulaObjectVars;
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
    formulaObject["parentKey"] = formulaObjectVars.split(".")[0];
    formulaObject["childKey"] = formulaObjectVars.split(".")[1];
  } else if (
    formulaObject["action"] == "sumOf" ||
    formulaObject["action"] == "diffOf" ||
    formulaObject["action"] == "averageOf" ||
    formulaObject["action"] == "multipleOf"
  ) {
    noOfFieldsKeys = formulaObjectVars.split(",").map((item) => item.trim());
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
  } else if ("formatnumber") {
    formulaObject["noOfFieldsKeys"] = 0;
    formulaObject["fieldKey"] = formulaObjectVars.split(",")[0];
    formulaObject["decimalLevel"] = formulaObjectVars.split(",")[1];
  } else if ("agefrom") {
    formulaObject["noOfFieldsKeys"] = 0;
    formulaObject["fieldKey"] = formulaObjectVars.split(",")[0];
    // formulaObject["decimalLevel"] = formulaObjectVars.split(",")[1];
  }

  console.log("mainFormFields_fetchFormulaObject:End---");
  return formulaObject;
}

export function fetchFormulaObjectForConditionalElementV2(
  formulaValue,
  superParentTemplateKey
) {
  var formulaObject = {};

  console.log(
    "conditionalFormInputs_fetchFormulaObjectForConditionalElementV2:start----"
  );

  console.log("conditionalFormInputs_formulaValue", formulaValue);

  formulaObject["action"] = formulaValue.split("(")[0];
  console.log(
    "conditionalFormInputs_formulaValue_action",
    formulaObject["action"]
  );

  var noOfFieldsKeys = [];
  var formulaObjectVars = formulaValue.substring(
    formulaValue.indexOf("(") + 1,
    formulaValue.lastIndexOf(")")
  );

  formulaObject["actionString"] = formulaObjectVars;

  console.log("conditionalFormInputs_formulaObjectVars", formulaObjectVars);

  /*
  formulaObject["parentKey"] =
    formulaObjectVars.split(".")[0] + superParentTemplateKey;
  formulaObject["childKey"] = formulaObjectVars.split(".")[1];
    */

  if (formulaObject["action"] == "eval") {
    //var formulaObjectVarsClean=formulaObjectVars.replace("(","");
    //formulaObjectVarsClean=formulaObjectVarsClean.replace(")","");
    var formulaObjectVarsClean = formulaObjectVars.replace(/[()]/g, "");
    noOfFieldsKeys = formulaObjectVarsClean
      .split(/[+-/%*]+/)
      .map((item) => item.trim());
    //noOfFieldsKeys = formulaObjectVars.split(/[+-/%*]+/).map(item => item.trim());
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
  } else if (
    formulaObject["action"] == "sum" ||
    formulaObject["action"] == "diff" ||
    formulaObject["action"] == "average" ||
    formulaObject["action"] == "multiple"
  ) {
    noOfFieldsKeys[0] = formulaObjectVars;
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
    formulaObject["parentKey"] = formulaObjectVars.split(".")[0];
    formulaObject["childKey"] = formulaObjectVars.split(".")[1];
  } else if (
    formulaObject["action"] == "sumOf" ||
    formulaObject["action"] == "diffOf" ||
    formulaObject["action"] == "averageOf" ||
    formulaObject["action"] == "multipleOf"
  ) {
    noOfFieldsKeys = formulaObjectVars.split(",").map((item) => item.trim());
    formulaObject["noOfFieldsKeys"] = noOfFieldsKeys;
  } else if ("formatnumber") {
    formulaObject["noOfFieldsKeys"] = 0;
    formulaObject["fieldKey"] = formulaObjectVars.split(",")[0];
    formulaObject["decimalLevel"] = formulaObjectVars.split(",")[1];
  } else if ("agefrom") {
    formulaObject["noOfFieldsKeys"] = 0;
    formulaObject["fieldKey"] = formulaObjectVars.split(",")[0];
    // formulaObject["decimalLevel"] = formulaObjectVars.split(",")[1];
  }

  console.log(
    "conditionalFormInputs_fetchFormulaObjectForConditionalElementV2:end----"
  );
  return formulaObject;
}

function processParentChildKeyRelation(noOfFieldsKeys) {
  return noOfFieldsKeys[1] + "" + noOfFieldsKeys[0];
}

const keysToFormInputTemplateKeys = (fieldKeys) => {
  var formInputTemplateKeys = [];
  if (fieldKeys != undefined && fieldKeys.length > 0) {
    fieldKeys.forEach((fieldKey) => {
      fieldKey = fieldKey.replace(/\s/g, "");

      console.log(
        "mainFormFields_keysToFormInputTemplateKeys_fieldKey",
        fieldKey
      );
      var noOfFieldsKeys = fieldKey.split(".");
      console.log(
        "mainFormFields_keysToFormInputTemplateKeys_noOfFieldsKeys",
        noOfFieldsKeys
      );
      console.log(
        "mainFormFields_keysToFormInputTemplateKeys_noOfFieldsKeys.length",
        noOfFieldsKeys.length
      );

      if (noOfFieldsKeys.length == 1) {
        //process Key without parentKeyStructure
        /*      
      formInputTemplateKeys.push(fieldKey.replace(/\s/g,''));      
      console.log(
        "mainFormFields_validateFormfieldKey",
        validateFormfieldKey(fieldKey.replace(/\s/g,''))
      );
      console.log(
        "mainFormFields_validateFormfieldKey_test",
        validateFormfieldKey("4")
      );
      */
        if (validateFormfieldKey(fieldKey)) {
          formInputTemplateKeys.push(fieldKey);
        }
      } else {
        //process For internal Conditional element
        formInputTemplateKeys.push(
          processParentChildKeyRelation(noOfFieldsKeys).replace(/\s/g, "")
        );
      }
    });
  }
  return formInputTemplateKeys;
};

function validateFormfieldKey(key2validate) {
  var regExp = /[a-zA-Z]/g;

  if (regExp.test(key2validate)) {
    /* do something if letters are found in your string */
    return true;
  } else {
    /* do something if letters are not found in your string */
    return false;
  }
}

export function processFormulaObjectV2(formulaObject, formData) {
  var returnResult = 0;
  //Number
  console.log("mainFormFields_processFormulaObjectV2:Start----");
  console.log(
    "mainFormFields_processFormulaObjectV2_formulaObject",
    formulaObject
  );
  console.log("mainFormFields_processFormulaObjectV2_formData", formData);

  console.log(
    "mainFormFields_processFormulaObjectV2_formulaObject.noOfFieldsKeys",
    formulaObject.noOfFieldsKeys
  );

  var toFormInputTemplateKeys = [];
  if (formulaObject.noOfFieldsKeys != 0) {
    toFormInputTemplateKeys = keysToFormInputTemplateKeys(
      formulaObject.noOfFieldsKeys
    );
  }

  console.log(
    "mainFormFields_processFormulaObjectV2_toFormInputTemplateKeys",
    toFormInputTemplateKeys
  );
  //evaluate if formulaObject.action=eval

  if (formulaObject.action == "eval") {
    var actionStringtoCalulate = formulaObject.actionString;
    toFormInputTemplateKeys.forEach((fieldKey) => {
      console.log(
        "mainFormFields_processFormulaObjectV2_formData[fieldKey]",
        formData[fieldKey]
      );
      if (formData[fieldKey] == undefined) {
        actionStringtoCalulate = actionStringtoCalulate.replace(
          new RegExp(fieldKey, "gi"),
          Number("0")
        );
      } else {
        actionStringtoCalulate = actionStringtoCalulate.replace(
          new RegExp(fieldKey, "gi"),
          Number(formData[fieldKey])
        );
      }
    });
    console.log(
      "mainFormFields_processFormulaObjectV2_actionStringtoCalulate",
      actionStringtoCalulate
    );
    returnResult = evaluate(actionStringtoCalulate);
  } else if (formulaObject.action == "sumOf") {
    console.log("mainFormFields_sumOf_Start");
    toFormInputTemplateKeys.forEach((fieldKey) => {
      console.log(
        "mainFormFields_sumOf_formData[fieldKey]",
        formData[fieldKey]
      );
      console.log(
        "mainFormFields_sumOf_formData[fieldKey]",
        Number(formData[fieldKey])
      );
      if (formData[fieldKey] == undefined) {
        returnResult = returnResult + 0;
      } else {
        returnResult = returnResult + Number(formData[fieldKey]);
      }
    });
    console.log("mainFormFields_sumOf_returnResult", returnResult);
    console.log("mainFormFields_sumOf_END");
  } else if (formulaObject.action == "diffOf") {
    toFormInputTemplateKeys.forEach((fieldKey) => {
      console.log(
        "mainFormFields_processFormulaObjectV2_formData[fieldKey]",
        formData[fieldKey]
      );
      if (formData[fieldKey] == undefined) {
        returnResult = returnResult - 0;
      } else {
        // returnResult = returnResult - Number(formData[fieldKey]);
        if (returnResult > 0) {
          returnResult = returnResult - Number(formData[fieldKey]);
        } else {
          returnResult = Number(formData[fieldKey]) - returnResult;
        }
      }
    });
  } else if (formulaObject.action == "averageOf") {
    toFormInputTemplateKeys.forEach((fieldKey) => {
      console.log(
        "mainFormFields_processFormulaObjectV2_formData[fieldKey]",
        formData[fieldKey]
      );
      if (formData[fieldKey] == undefined) {
        returnResult = returnResult + 0;
      } else {
        returnResult = returnResult + Number(formData[fieldKey]);
      }
    });

    returnResult = returnResult / toFormInputTemplateKeys.length;
  } else if (formulaObject.action == "multipleOf") {
    returnResult = 1;
    toFormInputTemplateKeys.forEach((fieldKey) => {
      console.log(
        "mainFormFields_processFormulaObjectV2_formData[fieldKey]",
        formData[fieldKey]
      );
      if (formData[fieldKey] == undefined) {
        returnResult = returnResult * 1;
      } else {
        returnResult = returnResult * Number(formData[fieldKey]);
      }
    });
  } else if (formulaObject.action == "sum") {
    returnResult = 0;
    console.log("mainFormFields_ActionSum:Start");
    var parentValue = formData[formulaObject.parentKey];

    console.log("mainFormFields_ActionSum_parentValue", parentValue);

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        //let formKeyToCalculate = formulaObject.childKey + "" +formulaObject.parentKey + "" + i;
        let formKeyToCalculate = toFormInputTemplateKeys[0] + "" + i;
        console.log(
          "mainFormFields_formData_value_" + formKeyToCalculate + "_",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          //console.log("mainFormFields_ResultSet_at_before_"+formKeyToCalculate,returnResult);
          returnResult = returnResult + 0;
          //console.log("mainFormFields_ResultSet_at_after_"+formKeyToCalculate,returnResult);
        } else {
          //console.log("mainFormFields_ResultSet_at_before_"+formKeyToCalculate,returnResult);
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
          //returnResult = returnResult + formData[formKeyToCalculate];
          //console.log("mainFormFields_ResultSet_at_after_"+formKeyToCalculate,returnResult);
        }
      }
    }

    console.log("mainFormFields_ActionSum:returnResult", returnResult);
    console.log("mainFormFields_ActionSum:END");
  } else if (formulaObject.action == "diff") {
    var parentValue = formData[formulaObject.parentKey];
    console.log(
      "mainFormFields_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        //let formKeyToCalculate = formulaObject.childKey + "" +formulaObject.parentKey + "" + i;
        let formKeyToCalculate = toFormInputTemplateKeys[0] + "" + i;
        console.log(
          "mainFormFields_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "mainFormFields_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult - 0;
        } else {
          returnResult = returnResult - Number(formData[formKeyToCalculate]);
        }
      }
    }
  } else if (formulaObject.action == "multiple") {
    var parentValue = formData[formulaObject.parentKey];
    console.log(
      "mainFormFields_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      returnResult = 1;
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        //let formKeyToCalculate = formulaObject.childKey + "" +formulaObject.parentKey + "" + i;
        let formKeyToCalculate = toFormInputTemplateKeys[0] + "" + i;
        console.log(
          "mainFormFields_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "mainFormFields_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult * 1;
        } else {
          returnResult = returnResult * Number(formData[formKeyToCalculate]);
        }
      }
    }
  } else if (formulaObject.action == "average") {
    var parentValue = formData[formulaObject.parentKey];
    console.log(
      "mainFormFields_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        let formKeyToCalculate = toFormInputTemplateKeys[0] + "" + i;
        console.log(
          "mainFormFields_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "mainFormFields_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult + 0;
        } else {
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
        }
      }
      returnResult = returnResult / ifPopulateCount;
    }
  } else if (formulaObject.action == "formatnumber") {
    console.log("formatnumber_", formulaObject);
    const keyToFormat = formulaObject.fieldKey;

    console.log("formatnumber_value22calulate", formData[keyToFormat]);

    return decimalNumberFormatter(
      formData[keyToFormat],
      formulaObject.decimalLevel
    );
  } else if (formulaObject.action == "agefrom") {
    //Added On 17-11-2021

    // console.log(
    //   "agefrom_",
    //   formulaObject
    // );
    const keyToFormat = formulaObject.fieldKey;

    // console.log(
    //   "agefrom_value22calulate",
    //   formData[keyToFormat]
    // );

    if (formData[keyToFormat] != undefined) {
      var dateForAge = formData[keyToFormat].split("-").reverse().join("-");
      // console.log("agefrom_dateForAge",dateForAge)
      // console.log("agefrom_getAgeFromDate",getAgeFromDate(dateForAge))
      return getAgeFromDate(dateForAge);
    }
    return 0;
  }

  //getAgeFromDate

  console.log(
    "mainFormFields_processFormulaObjectV2_returnResult",
    returnResult
  );
  console.log("mainFormFields_processFormulaObjectV2:End----");
  //return returnResult;
  return returnResult.toFixed(2);
  //return Number(returnResult.toFixed(2));
}

export function processFormulaObjectForConditionalElementV2(
  formulaObject,
  formData,
  superParentTemplateKey
) {
  var returnResult = 0;

  console.log(
    "conditionalFormInputs_processFormulaObjectForConditionalElementV2:Start------"
  );

  console.log("conditionalFormInputs_formulaObject", formulaObject);

  console.log(
    "conditionalFormInputs_superParentTemplateKey",
    superParentTemplateKey
  );

  console.log(
    "conditionalFormInputs_processFormulaObjectV2_formulaObject.noOfFieldsKeys",
    formulaObject.noOfFieldsKeys
  );

  var toFormInputTemplateKeys = [];
  if (formulaObject.noOfFieldsKeys != 0) {
    toFormInputTemplateKeys = keysToFormInputTemplateKeys(
      formulaObject.noOfFieldsKeys
    );
  }

  // console.log(
  //   "conditionalFormInputs_processFormulaObjectV2_toFormInputTemplateKeys",
  //   toFormInputTemplateKeys
  // );

  if (formulaObject.action == "eval") {
    var actionStringtoCalulate = formulaObject.actionString;

    toFormInputTemplateKeys.forEach((fieldKey) => {
      let formKeyToCalculate = fieldKey + "" + superParentTemplateKey; // + "" + 0;

      console.log("conditionalFormInputs_fieldKey", fieldKey);

      console.log(
        "conditionalFormInputs_formKeyToCalculate",
        formKeyToCalculate
      );

      console.log(
        "conditionalFormInputs_processFormulaObjectV2_formData[formKeyToCalculate]",
        formData[formKeyToCalculate]
      );

      if (formData[formKeyToCalculate] == undefined) {
        actionStringtoCalulate = actionStringtoCalulate.replace(
          new RegExp(fieldKey, "gi"),
          Number("0")
        );
      } else {
        actionStringtoCalulate = actionStringtoCalulate.replace(
          new RegExp(fieldKey, "gi"),
          Number(formData[formKeyToCalculate])
        );
      }
    });
    console.log(
      "conditionalFormInputs_processFormulaObjectV2_actionStringtoCalulate",
      actionStringtoCalulate
    );

    returnResult = evaluate(actionStringtoCalulate);
  } else if (formulaObject.action == "sumOf") {
    toFormInputTemplateKeys.forEach((fieldKey) => {
      let formKeyToCalculate = fieldKey + "" + superParentTemplateKey; // + "" + 0;

      console.log(
        "conditionalFormInputs_processFormulaObjectV2_formData[fieldKey]",
        formData[formKeyToCalculate]
      );
      if (formData[formKeyToCalculate] == undefined) {
        returnResult = returnResult + 0;
      } else {
        returnResult = returnResult + Number(formData[formKeyToCalculate]);
      }
    });
  } else if (formulaObject.action == "diffOf") {
    toFormInputTemplateKeys.forEach((fieldKey) => {
      let formKeyToCalculate = fieldKey + "" + superParentTemplateKey; // + "" + 0;
      console.log(
        "conditionalFormInputs_processFormulaObjectV2_formData[fieldKey]",
        formData[formKeyToCalculate]
      );
      if (formData[formKeyToCalculate] == undefined) {
        returnResult = returnResult - 0;
      } else {
        // returnResult = returnResult - Number(formData[formKeyToCalculate]);
        if (returnResult > 0) {
          returnResult = returnResult - Number(formData[formKeyToCalculate]);
        } else {
          returnResult = Number(formData[formKeyToCalculate]) - returnResult;
        }
      }
    });
  } else if (formulaObject.action == "averageOf") {
    toFormInputTemplateKeys.forEach((fieldKey) => {
      let formKeyToCalculate = fieldKey + "" + superParentTemplateKey; // + "" + 0;
      console.log(
        "conditionalFormInputs_processFormulaObjectV2_formData[fieldKey]",
        formData[formKeyToCalculate]
      );
      if (formData[formKeyToCalculate] == undefined) {
        returnResult = returnResult + 0;
      } else {
        returnResult = returnResult + Number(formData[formKeyToCalculate]);
      }
    });
    returnResult = returnResult / toFormInputTemplateKeys.length;
  } else if (formulaObject.action == "multipleOf") {
    returnResult = 1;
    toFormInputTemplateKeys.forEach((fieldKey) => {
      let formKeyToCalculate = fieldKey + "" + superParentTemplateKey; // + "" + 0;
      console.log(
        "conditionalFormInputs_processFormulaObjectV2_formData[fieldKey]",
        formData[formKeyToCalculate]
      );
      if (formData[formKeyToCalculate] == undefined) {
        returnResult = returnResult * 1;
      } else {
        returnResult = returnResult * Number(formData[formKeyToCalculate]);
      }
    });
  } else if (formulaObject.action == "sum") {
    console.log(
      "conditionalFormInputs_superParentTemplateKey",
      superParentTemplateKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey",
      formulaObject.parentKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey+superParentTemplateKey",
      formulaObject.parentKey + "" + superParentTemplateKey
    );

    var parentValue =
      formData[formulaObject.parentKey + "" + superParentTemplateKey];
    console.log(
      "conditionalFormInputs_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        let formKeyToCalculate =
          toFormInputTemplateKeys[0] + "" + superParentTemplateKey + "" + i;
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult + 0;
        } else {
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
        }
      }
    }
  } else if (formulaObject.action == "diff") {
    console.log(
      "conditionalFormInputs_superParentTemplateKey",
      superParentTemplateKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey",
      formulaObject.parentKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey+superParentTemplateKey",
      formulaObject.parentKey + "" + superParentTemplateKey
    );

    var parentValue =
      formData[formulaObject.parentKey + "" + superParentTemplateKey];
    console.log(
      "conditionalFormInputs_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        let formKeyToCalculate =
          toFormInputTemplateKeys[0] + "" + superParentTemplateKey + "" + i;
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult - 0;
        } else {
          returnResult = returnResult - Number(formData[formKeyToCalculate]);
        }
      }
    }
  } else if (formulaObject.action == "multiple") {
    console.log(
      "conditionalFormInputs_superParentTemplateKey",
      superParentTemplateKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey",
      formulaObject.parentKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey+superParentTemplateKey",
      formulaObject.parentKey + "" + superParentTemplateKey
    );

    var parentValue =
      formData[formulaObject.parentKey + "" + superParentTemplateKey];
    console.log(
      "conditionalFormInputs_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      returnResult = 1;
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        let formKeyToCalculate =
          toFormInputTemplateKeys[0] + "" + superParentTemplateKey + "" + i;
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult * 1;
        } else {
          returnResult = returnResult * Number(formData[formKeyToCalculate]);
        }
      }
    }
  } else if (formulaObject.action == "average") {
    console.log(
      "conditionalFormInputs_superParentTemplateKey",
      superParentTemplateKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey",
      formulaObject.parentKey
    );

    console.log(
      "conditionalFormInputs_formulaObject.parentKey+superParentTemplateKey",
      formulaObject.parentKey + "" + superParentTemplateKey
    );

    var parentValue =
      formData[formulaObject.parentKey + "" + superParentTemplateKey];
    console.log(
      "conditionalFormInputs_processFormulaObjectV2_parentValue",
      parentValue
    );

    if (parentValue !== undefined) {
      let ifPopulateCount = 1;
      if (isNaN(parentValue)) {
        //Do Nothing
      } else {
        ifPopulateCount = parseInt(parentValue);
      }

      for (var i = 0; i < ifPopulateCount; i++) {
        let formKeyToCalculate =
          toFormInputTemplateKeys[0] + "" + superParentTemplateKey + "" + i;
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formKeyToCalculate",
          formKeyToCalculate
        );
        console.log(
          "conditionalFormInputs_processFormulaObjectV2_formData[formKeyToCalculate]",
          formData[formKeyToCalculate]
        );

        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult + 0;
        } else {
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
        }
      }
      returnResult = returnResult / ifPopulateCount;
    }
  } else if (formulaObject.action == "formatnumber") {
    // console.log(
    //   "formatnumber_condition",
    //   formulaObject
    // );
    //formulaObject.parentKey + "" + superParentTemplateKey

    const keyToFormat = formulaObject.fieldKey + "" + superParentTemplateKey;
    //formData[keyToFormat]

    // console.log(
    //   "formatnumber_condition_value22calulate",
    //   formData[keyToFormat]
    // );
    return decimalNumberFormatter(
      formData[keyToFormat],
      formulaObject.decimalLevel
    );
  } else if (formulaObject.action == "agefrom") {
    //added on 17-11-2021

    // console.log(
    //   "agefrom_",
    //   formulaObject
    // );

    const keyToFormat = formulaObject.fieldKey + "" + superParentTemplateKey;

    // console.log(
    //   "agefrom_value22calulate",
    //   formData[keyToFormat]
    // );

    if (formData[keyToFormat] != undefined) {
      var dateForAge = formData[keyToFormat].split("-").reverse().join("-");
      // console.log("agefrom_dateForAge", dateForAge);
      // console.log("agefrom_getAgeFromDate", getAgeFromDate(dateForAge));
      return getAgeFromDate(dateForAge);
    }
    return 0;
  }

  console.log(
    "conditionalFormInputs_processFormulaObjectForConditionalElementV2_returnResult",
    returnResult
  );
  console.log(
    "conditionalFormInputs_processFormulaObjectForConditionalElementV2:END------"
  );

  //return returnResult;//Old
  return returnResult.toFixed(2);
  //return Number(returnResult.toFixed(2));
}

export function fetchFormulaObject(formulaValue) {
  var formulaObject = {};

  console.log("mainFormFields_fetchFormulaObject_formulaValue", formulaValue);
  formulaObject["action"] = formulaValue.split("=")[0];

  var formulaObjectVars = formulaValue.substring(
    formulaValue.lastIndexOf("(") + 1,
    formulaValue.lastIndexOf(")")
  );

  console.log(
    "mainFormFields_fetchFormulaObject_formulaObjectVars",
    formulaObjectVars
  );

  formulaObject["parentKey"] = formulaObjectVars.split(".")[0];
  formulaObject["childKey"] = formulaObjectVars.split(".")[1];

  return formulaObject;
}

export function processFormulaObject(formulaObject, parentValue, formData) {
  var returnResult = 0;

  console.log(
    "mainFormFields_processFormulaObject_formulaObject",
    formulaObject
  );
  console.log("mainFormFields_processFormulaObject_parentValue", parentValue);

  if (parentValue !== undefined) {
    let ifPopulateCount = 1;
    if (isNaN(parentValue)) {
      //Do Nothing
    } else {
      ifPopulateCount = parseInt(parentValue);
    }

    //pricenoofitems0
    for (var i = 0; i < ifPopulateCount; i++) {
      let formKeyToCalculate =
        formulaObject.childKey + "" + formulaObject.parentKey + "" + i;
      console.log(
        "mainFormFields_processFormulaObject_formKeyToCalculate",
        formKeyToCalculate
      );
      console.log(
        "mainFormFields_processFormulaObject_formData[formKeyToCalculate]",
        formData[formKeyToCalculate]
      );

      if (formulaObject.action == "sum") {
        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult + 0;
        } else {
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
        }
      } else if (formulaObject.action == "subtraction") {
        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult - 0;
        } else {
          returnResult = returnResult - Number(formData[formKeyToCalculate]);
        }
      }
    }
  }

  return returnResult;
}

export function fetchFormulaObjectForConditionalElement(
  formulaValue,
  superParentTemplateKey
) {
  var formulaObject = {};

  console.log(
    "conditionalFormInputs_fetchFormulaObject_formulaValue",
    formulaValue
  );
  formulaObject["action"] = formulaValue.split("=")[0];

  var formulaObjectVars = formulaValue.substring(
    formulaValue.lastIndexOf("(") + 1,
    formulaValue.lastIndexOf(")")
  );

  console.log(
    "conditionalFormInputs_fetchFormulaObject_formulaObjectVars",
    formulaObjectVars
  );

  formulaObject["parentKey"] =
    formulaObjectVars.split(".")[0] + superParentTemplateKey;
  formulaObject["childKey"] = formulaObjectVars.split(".")[1];
  return formulaObject;
}

export function processFormulaObjectForConditionalElement(
  formulaObject,
  parentValue,
  formData
) {
  var returnResult = 0;

  console.log(
    "mainFormFields_processFormulaObject_formulaObject",
    formulaObject
  );
  console.log("mainFormFields_processFormulaObject_parentValue", parentValue);

  if (parentValue !== undefined) {
    let ifPopulateCount = 1;
    if (isNaN(parentValue)) {
      //Do Nothing
    } else {
      ifPopulateCount = parseInt(parentValue);
    }

    for (var i = 0; i < ifPopulateCount; i++) {
      //pricenoofitemsinshowitemtables00
      let formKeyToCalculate =
        formulaObject.childKey + "" + formulaObject.parentKey + "" + i;
      console.log(
        "mainFormFields_processFormulaObject_formKeyToCalculate",
        formKeyToCalculate
      );
      console.log(
        "mainFormFields_processFormulaObject_formData[formKeyToCalculate]",
        formData[formKeyToCalculate]
      );

      if (formulaObject.action == "sum") {
        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult + 0;
        } else {
          returnResult = returnResult + Number(formData[formKeyToCalculate]);
        }
      } else if (formulaObject.action == "subtraction") {
        if (formData[formKeyToCalculate] == undefined) {
          returnResult = returnResult - 0;
        } else {
          returnResult = returnResult - Number(formData[formKeyToCalculate]);
        }
      }
    }
  }

  return returnResult;
}

function digitAmountToWordWithDecimal(amount) {
  const a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];

  const b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const regex = /^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/;

  const getLT20 = (n) => a[Number(n)];
  const getGT20 = (n) => b[n[0]] + " " + a[n[1]];

  const num = Number(amount);
  if (isNaN(num)) return "";
  if (num === 0) return "zero";

  const numStr = num.toString();
  if (numStr.length > 9) {
    throw new Error("overflow"); // Does not support converting more than 9 digits yet
  }

  const [, n1, n2, n3, n4, n5] = ("000000000" + numStr).substr(-9).match(regex); // left pad zeros

  let str = "";
  str += n1 != 0 ? (getLT20(n1) || getGT20(n1)) + "crore " : "";
  str += n2 != 0 ? (getLT20(n2) || getGT20(n2)) + "lakh " : "";
  str += n3 != 0 ? (getLT20(n3) || getGT20(n3)) + "thousand " : "";
  str += n4 != 0 ? getLT20(n4) + "hundred " : "";
  str += n5 != 0 && str != "" ? "and " : "";
  str += n5 != 0 ? getLT20(n5) || getGT20(n5) : "";

  return str.trim();
}

function convertNumberToWords(amount) {
  var words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (var i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (var i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    var value = "";
    for (var i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Crores ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Lakhs ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }
  return words_string;
}

export function digitAmountToWord(amount) {
  if (amount == undefined) {
    return "";
  } else {
    var nums = amount.toString().split(".");
    //var whole = digitAmountToWordWithDecimal(nums[0])
    var whole = convertNumberToWords(nums[0]);
    if (nums.length == 2) {
      //var fraction = digitAmountToWordWithDecimal(nums[1])
      var fraction = convertNumberToWords(nums[1]);
      return whole + " and " + fraction + " only";
    } else {
      return whole + " only";
    }
  }
  //return digitAmountToWordWithDecimal(amount) + " only"
}
